module.exports = __webpack_public_path__ + "static/img/loginbanner.37e42e81.png";